export default "__VITE_ASSET__14x__yS6Z4Ee$7STDgNF2Q__"